"use strict";

/**
 * @license
 * Copyright (c) 2014, 2018, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 */
define('appController',['ojs/ojcore', 'knockout', 'jquery', 'ojs/ojmodule-element-utils', 'ojs/ojmodule-element', 'ojs/ojrouter', 'ojs/ojknockout', 'ojs/ojarraytabledatasource', 'ojs/ojoffcanvas'], function (oj, ko, $, moduleUtils) {
  function ControllerViewModel() {
    var self = this; //for VKB workstation

    var getLocalWorkstationDetails = window.localStorage.getItem("workstationDetails___");
    self.isWorkStationFlowEnabled = ko.observable(getLocalWorkstationDetails !== null ? true : false);
    /** to get cookie by cookie name */

    var getCookie = function getCookie(cname) {
      var name = cname + "=";
      var ca = document.cookie.split(';');

      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];

        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }

        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }

      return null;
    }; //Fetch Language/Locale from user preference if user is identified in any OP screen instead of 
    //fetching from browser (eg: navigator.language as used above to consider default locale for user )


    var newLang = navigator.language;

    if (getCookie('userLocale') != null) {
      newLang = getCookie('userLocale');
      localStorage.setItem("lang", newLang);
    } else if (localStorage.getItem('lang') != null) {
      newLang = localStorage.getItem('lang');
    } else {
      localStorage.setItem("lang", newLang);
    }

    oj.Config.setLocale(newLang, function () {
      $('html').attr('lang', newLang);
    }); // Media queries for repsonsive layouts

    var smQuery = oj.ResponsiveUtils.getFrameworkQuery(oj.ResponsiveUtils.FRAMEWORK_QUERY_KEY.SM_ONLY);
    self.smScreen = oj.ResponsiveKnockoutUtils.createMediaQueryObservable(smQuery);
    var mdQuery = oj.ResponsiveUtils.getFrameworkQuery(oj.ResponsiveUtils.FRAMEWORK_QUERY_KEY.MD_UP);
    self.mdScreen = oj.ResponsiveKnockoutUtils.createMediaQueryObservable(mdQuery); // Router setup

    self.router = oj.Router.rootInstance;
    self.router.configure({
      'login': {
        isDefault: true
      },
      'forgotpass': {},
      'forgotmail': {},
      'setpwd': {},
      'resetpwd': {},
      'expiredpwd': {}
    });

    self.transitionHandler = function (context) {
      var currState = context.router.currentState().id; // console.log("transitionHandler : ", currState);

      if (currState == 'login') {
        // pre-flight request to validate referer and redirect to app
        $.ajax({
          url: "/oidc-provider/v1/oauth2/valid-referer",
          type: "GET",
          contentType: "application/json",
          async: false,
          error: function error(jqXHR, textStatus, errorThrown) {
            console.log(jqXHR, textStatus, errorThrown);

            if (jqXHR.status == 401 && jqXHR.responseJSON) {
              console.log("initiate redirect  - on invalid referer ");
              location.href = jqXHR.responseJSON.redirectUri;
              console.log("redirect done");
            }
          }
        });
        $.ajax({
          url: "/oidc-provider/v1/oauth2/appconfig",
          type: "GET",
          contentType: "application/json",
          async: true,
          success: function success(data, textStatus, jqXHR) {
            sessionStorage.setItem("isTelemetryEnabled", data.isTelemetryEnabled);
            sessionStorage.setItem("telemetryHost", data.telemetryHost);
          }
        });
      }

      self.showFooter(false);

      if (GLOBAL_CONFIG.useTranslationAPI === true) {
        GLOBAL_UTILS.lang.createLocalTranslation('openid');
      }

      self.showFooter(true);
      document.title = GLOBAL_UTILS.lang.get(currState, 'pageTitles'); // if(self.isWorkStationFlowEnabled()) {
      //   $("#pageContent").removeClass("oms-keyboard-main");
      //   $(".oj-offcanvas-outer-wrapper").removeClass("oms-keyboard-outer-wrapper oj-offcanvas-shift-up");
      //   const drawerBottomParams = {
      //       selector: "#bottomDrawer",
      //       content: "#mainOuter",
      //       autoDismiss: "none",
      //       displayMode: "overlay"
      //   };
      //   oj.OffcanvasUtils.close(drawerBottomParams);
      // }
    };

    oj.Router.transitionedToState.add(self.transitionHandler);
    oj.Router.defaults['urlAdapter'] = new oj.Router.urlParamAdapter();
    oj.ModuleBinding.defaults.modelPath = 'application/modules/';
    oj.ModuleBinding.defaults.viewPath = 'text!' + 'application/modules/'; //oj.ModuleBinding.defaults.viewSuffix = '.html'; //Commented as .html is the default suffix assumed if not provided

    ko.amdTemplateEngine.defaultPath = "application/global/templates";
    self.moduleConfig = ko.observable({
      'view': [],
      'viewModel': null
    });
    self.templName = ko.observable('');
    self.showFooter = ko.observable(true); //self.pageContentClass = ko.observable('');

    self.pageContentClass = ko.observable('oj-web-applayout-page');

    self.loadModule1 = function () {
      ko.computed(function () {
        var name = self.router.moduleConfig.name();
        var curState = self.router.stateId();
        var viewPath = "application/global/".concat(curState, "/").concat(curState, ".html");
        var modelPath = "application/global/".concat(curState, "/").concat(curState);
        var masterPromise = Promise.all([moduleUtils.createView({
          'viewPath': viewPath
        }), moduleUtils.createViewModel({
          'viewModelPath': modelPath
        })]);
        masterPromise.then(function (values) {
          self.moduleConfig({
            'view': values[0],
            'viewModel': values[1]
          });
        });
      });
    };

    self.loadModule = function () {
      ko.computed(function () {
        var curState = self.router.stateId();
        var templName = "../global/".concat(curState, "/").concat(curState);
        self.templName(templName);
      });
    };
  }

  return new ControllerViewModel();
});
